/*
   ══════════════════════════════════════════════════════════════════════════
   GENUSSFUX · FIRMENGESCHENKE-LANDINGPAGE
   Datei 2 von 5 · Konfigurator, Formular, Texte und Preise

   GEHÖRT IN:   Assets → genussfux.js
   STAND:       11.08.2026, 20:46

   Alle fünf Dateien gehören zu diesem einen Stand und müssen gemeinsam
   eingespielt werden. Fehlt eine oder ist sie älter, passen Gestaltung,
   Skript und Inhalt nicht mehr zueinander.

        1  Assets     → genussfux.css
        2  Assets     → genussfux.js               ◀ DAS HIER
        3  Sections   → genussfux-firmengeschenke
        4  Layout     → genussfux-landing
        5  Templates  → page.firmengeschenke

   Zum Prüfen: In allen fünf Dateien muss oben derselbe STAND stehen.

   Erzeugt aus index.html mit:  python werkzeuge/shopify-bauen.py
   Änderungen bitte dort machen, nicht hier – beim nächsten Bauen wären
   sie sonst weg. Anleitung: shopify/ANLEITUNG.md
   ══════════════════════════════════════════════════════════════════════════
*/

/* ══════════════════════════════════════════════════════════════════
   GENUSSFUX · FIRMENGESCHENKE 2026
   Alles, was sich ändern kann, steht im CONFIG-Block.
   Layout muss dafür nie angefasst werden.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* Läuft die Seite als Shopify-Unterseite, legt das Liquid-Template vorher
     window.GENUSSFUX_SHOPIFY an: Bild-Adresse und welche Bildgruppen hochgeladen
     sind. Fehlt das Objekt, läuft die Seite als eigenständige index.html. */
  var SHOP = (typeof window !== 'undefined' && window.GENUSSFUX_SHOPIFY) || null;

  /* ─── Fotos aus dem Shopify-Dateibereich ──────────────────────────────────
     Basisadresse einmal hier, damit unten nur die Dateinamen stehen.
     Shopifys CDN kann Zuschnitt und Größe selbst rechnen: Die angehängten
     Parameter sparen eigene Zuschnitte und liefern jedem Gerät die passende
     Auflösung. Ein Foto austauschen heißt dann: dieselbe Datei ersetzen. */
  var SHOP_BILD = 'https://cdn.shopify.com/s/files/1/0772/9666/4917/files/';

  /* Die Sortenfotos liegen als 2500 × 2500 im Shop – quadratisch, mit viel Weiß
     um die Tafel. Gemessen füllt die Tafel nur 45,7 % der Bildbreite (29,5 % bis
     75,2 %) und 84,8 % der Höhe. Ein 3:4-Zuschnitt lässt davon so viel Weiß
     stehen, dass die Tafel am Handy 62 % der Kachel füllt – am Schirm, wo die
     Kachel nur 204 px breit ist, wird das Etikett dadurch unleserlich.

     Deshalb zwei Zuschnitte. Am Schirm ein schmaler, der eng an der Tafel liegt:
     0,56 entspricht genau dem Seitenverhältnis der Tafel samt Schatten, und weil
     crop=center um die Bildmitte schneidet, ist 56 % Breite das Engste, das den
     Schatten rechts (bis 75,2 %) noch mitnimmt. Die Tafel füllt damit 82 % der
     Kachel statt 61 %.

     Die Breite ist am Bedarf bemessen, nicht großzügig geschätzt: Am Schirm ist
     die Kachel 204 px breit, ein sehr scharfes Display braucht davon 408 echte
     Bildpunkte. 700 lässt dafür noch 1,7-fach Luft. Gemessen als WebP kosten die
     fünf Fotos damit 351 KB statt 258 KB im alten Zuschnitt – und weil der neue
     Ausschnitt eng an der Tafel liegt, entfallen von diesen Punkten kaum welche
     auf weißen Hintergrund. Sie werden erst beim Scrollen geladen. */
  var SORTE_ZUSCHNITT       = '&width=750&height=1000&crop=center';   // 3:4  · Handy
  var SORTE_ZUSCHNITT_GROSS = '&width=700&height=1250&crop=center';   // 0,56 · ab 700 px
  var PAKET_ZUSCHNITT = '&width=1200&height=900&crop=center';   // 4:3 für die Ergebniskarte

  var CONFIG = {

    /* ─────────────────────────────────────────────────────────
       1 · FIRMA & KONTAKT   ← BITTE VOR LIVE-GANG AUSFÜLLEN
       ───────────────────────────────────────────────────────── */
    firma: {
      firmenname:  'Schickmaier KG',
      adresse:     'Bergsleithenstraße 23 · 4643 Pettenbach, Österreich',
      telefon:     '0660 55 86 46 9',
      telefonLink: '+436605586469',           // für den tel:-Link, international
      /* Dieselbe Adresse wie im Impressum. Sie steht im Fuß, im Erfolgstext und
         als Rettungsanker in der Fehlermeldung des Formulars – wenn sie nicht
         erreichbar ist, geht ein Lead endgültig verloren. */
      email:       'genussfux@schickmaier.at',
      impressum:   'https://genussfux.at/policies/legal-notice',        // TODO prüfen
      datenschutz: 'https://genussfux.at/policies/privacy-policy'       // TODO prüfen
    },

    /* ─────────────────────────────────────────────────────────
       2 · BEWERTUNGS-HINWEIS
       Erscheint in der Vertrauenszeile im Hero und als runder
       Stempel bei den Stimmen. Beide Felder auf null setzen,
       dann wird gar nichts angezeigt.
       Achtung: Hier steht bewusst KEIN Sterne-Durchschnitt für
       Google – dafür bräuchte es die echte Zahl vom Profil.
       ───────────────────────────────────────────────────────── */
    bewertung: {
      zeile:   'über 400 Fünf-Sterne-Bewertungen',
      stempel: '400+ Fünf-Sterne-Bewertungen'
    },

    /* ─────────────────────────────────────────────────────────
       3 · STEUER & WÄHRUNG
       ───────────────────────────────────────────────────────── */
    ustSatz:      0.10,   // 10 % auf Lebensmittel
    freibetragMA: 186,    // § 3 Abs 1 Z 14 EStG, pro Person und Jahr

    /* ─────────────────────────────────────────────────────────
       4 · DIE SORTEN
       ───────────────────────────────────────────────────────── */
    /* Kakaoanteile von Manuel bestätigt am 11.08.2026: Erdbeer Chili 56 %,
       Wohlfühl Ritual 75 %. Namen und Schokoladenart stammen von den
       Verpackungsfotos. Die Herkunftsangaben stehen nicht auf der Verpackung –
       sie kommen aus dem Briefing und sind nicht gegengeprüft. */
    /* Die Fotos liegen bereits im Shopify-Dateibereich. Die angehängten
       Parameter lassen Shopifys CDN den 3:4-Zuschnitt und die Größe selbst
       rechnen – dadurch braucht es keine eigenen Zuschnitte mehr, und wenn
       du ein Foto austauschst, reicht es, dieselbe Datei zu ersetzen. */
    sorten: [
      { id: 'erdbeer-chili',    name: 'Erdbeer Chili',   detail: '56 % · Edelbitter · Peru',
        datei: 'erdbeer-chili_front_web.jpg?v=1773993973' },
      { id: 'walnuss',          name: 'Walnuss Honig',   detail: '39 % · Milch · Dom. Rep.',
        datei: 'walnuss-honig-schoko_front_web.jpg?v=1773993973' },
      { id: 'haselnuss',        name: 'Haselnuss',       detail: '39 % · Milch · Dom. Rep.',
        datei: 'haselnuss-schoko_front_web.jpg?v=1773993973' },
      { id: 'salty-caramel',    name: 'Salty Caramel',   detail: '39 % · Milch · Dom. Rep.',
        datei: 'Salty-Caramel_Front_web.jpg?v=1773993973' },
      { id: 'wohlfuehl-ritual', name: 'Wohlfühl Ritual', detail: '75 % · Edelbitter · Belize',
        /* Premium-Tafel: 7,60 € Firmenpreis statt 5,90 € laut Preisliste 2026.
           Der Aufpreis erscheint als Hinweis unter der Sortenwahl. In Schokoladen-Set
           und Holzbox ist sie bereits eingerechnet. */
        aufpreis: 1.70,
        datei: 'wohlfuehl-ritual-schoko_front_web.jpg?v=1771521050' }
    ],

    /* ─────────────────────────────────────────────────────────
       5 · DIE GESCHENK-LEITER  ·  Preisliste 2026
       vonBudget / bisBudget = Zuordnung des Reglers zum Paket.
       Der Regler zeigt immer den FESTPREIS des Pakets, nicht
       den eingestellten Budgetwert.
       staffel = Mengenrabatt, absteigend. Leer = mengenunabhängig.
       ⚠ Holzkisten-Preis und die Selbstkosten von Creme und Honig
         vor dem Live-Gang gegen echte Werte prüfen (siehe README).
       ───────────────────────────────────────────────────────── */
    pakete: [
      {
        stufe: 1, id: 'tafel', name: 'Die Tafel',
        vonBudget: 5, bisBudget: 9,
        preis: 5.90,
        staffel: [
          { ab: 500, preis: 4.90 },
          { ab: 250, preis: 5.30 },
          { ab: 100, preis: 5.60 }
        ],
        mindestmenge: 20,
        bild: '03-tafel.jpg',
        foto: SHOP_BILD + 'personalisierte-Schokolade-10.jpg?v=1786455671' + PAKET_ZUSCHNITT,
        mischkarton: true,
        inhalt: [
          '1 Bio-Tafel, 100 g, handgeschöpft',
          'Dein Logo als Siegel auf der Verpackung',
          'Sorte frei wählbar, Mischkarton möglich'
        ]
      },
      {
        stufe: 2, id: 'duo', name: 'Das Duo',
        vonBudget: 10, bisBudget: 15,
        preis: 12.90, staffel: [], mindestmenge: 20,
        bild: '04-duo.jpg',
        foto: SHOP_BILD + 'personalisierte-Schokolade-11.jpg?v=1786455672' + PAKET_ZUSCHNITT,
        /* Das Produktfoto zeigt zwei Tafeln ohne Täschchen – damit ist geklärt,
           dass das Geschenktäschchen erst ab drei Tafeln dazukommt. Die frühere,
           bewusst vage Zeile „Fertig zum Verschenken verpackt" hätte dem Foto
           widersprochen und ist deshalb raus. */
        inhalt: [
          '2 Bio-Tafeln, je 100 g',
          'Dein Logo als Etikett auf jeder Tafel',
          'Zwei Sorten deiner Wahl'
        ]
      },
      {
        stufe: 3, id: 'trio', name: 'Das Trio',
        vonBudget: 16, bisBudget: 21,
        preis: 18.90, staffel: [], mindestmenge: 20,
        bild: '05-trio.jpg',
        foto: SHOP_BILD + 'personalisierte-Schokolade-12.jpg?v=1786455672' + PAKET_ZUSCHNITT,
        inhalt: [
          '3 Bio-Tafeln, je 100 g',
          'Geschenktäschchen mit Schleife',
          'Logo-Etikett auf dem Täschchen'
        ]
      },
      {
        /* ⚠ Preis von mir gerechnet, nicht aus der Preisliste:
           4 × 5,90 € Warenwert + 1,30 € Verpackung. Dieselbe Logik wie beim
           Trio (3 × 5,90 + 1,20 = 18,90). Vor dem Live-Gang bestätigen. */
        stufe: 4, id: 'quartett', name: 'Das Quartett',
        vonBudget: 22, bisBudget: 27,
        preis: 24.90, staffel: [], mindestmenge: 20,
        bild: '06-quartett.jpg',
        foto: SHOP_BILD + 'personalisierte-Schokolade-13.jpg?v=1786455672' + PAKET_ZUSCHNITT,
        inhalt: [
          '4 Bio-Tafeln, je 100 g',
          'Geschenktäschchen mit Schleife',
          'Logo-Etikett auf dem Täschchen'
        ]
      },
      {
        stufe: 5, id: 'set', name: 'Das Schokoladen-Set',
        vonBudget: 28, bisBudget: 31,
        preis: 29.90, staffel: [], mindestmenge: 20,
        bild: '07-schokoladen-set.jpg',
        foto: SHOP_BILD + 'personalisierte-Schokolade-14.jpg?v=1786455672' + PAKET_ZUSCHNITT,
        inhalt: [
          'Alle fünf Sorten, je 100 g',
          'Erdbeer Chili, Walnuss Honig, Haselnuss, Salty Caramel',
          'Wohlfühl Ritual, 75 % Belize – Aufpreis bereits enthalten',
          'Geschenktäschchen mit Logo-Etikett'
        ]
      },
      {
        stufe: 6, id: 'genussbox', name: 'Die Genuss-Box',
        vonBudget: 32, bisBudget: 45,
        /* 10 wie in der FAQ und wie bei der Holzbox – vorher standen hier 20,
           was der eigenen Antwort auf „Wie viele Stück mindestens?" widersprach. */
        preis: 32.90, staffel: [], mindestmenge: 10,
        bild: '08-genuss-box.jpg',
        foto: SHOP_BILD + 'box-offen.jpg?v=1762937319' + PAKET_ZUSCHNITT,
        inhalt: [
          '2 Bio-Tafeln, je 100 g',
          'Haselnusscreme, 280 g',
          'Honig, 300 g, aus eigener Imkerei',
          'Weihnachtliche Geschenkbox mit Logo-Etikett'
        ]
      },
      {
        stufe: 7, id: 'holzbox', name: 'Die Holzbox',
        vonBudget: 46, bisBudget: 70,
        preis: 59.90, staffel: [], mindestmenge: 10,
        bild: '09-holzbox.jpg',
        foto: SHOP_BILD + 'personalisierte-Schokolade-18.jpg?v=1786455672' + PAKET_ZUSCHNITT,
        inhalt: [
          'Holzkiste mit Holzwolle, Logo-Etikett',
          'Alle fünf Sorten, je 100 g',
          'Honig, 450 g, aus eigener Imkerei',
          'Haselnusscreme, 280 g'
        ]
      },
      {
        stufe: 8, id: 'individuell', name: 'Individuell',
        vonBudget: 71, bisBudget: 100000,
        preis: null, individuell: true, abPreis: 70,
        staffel: [], mindestmenge: 10,
        bild: '10-individuell.jpg',
        /* Für alle individuellen Zusammenstellungen: Manuel als Sommelier.
           Das Original hat 6000 × 4000 und 2,9 MB – die Größenparameter sind
           hier keine Feinheit, sondern verhindern einen 3-MB-Download. */
        foto: SHOP_BILD + 'Manuel-Schokoladensommelier-5.jpg?v=1760503688' + PAKET_ZUSCHNITT,
        inhalt: [
          'Zusammenstellung nach deinem Wunsch',
          'Auf Wunsch eigene Rezeptur vom Schokoladensommelier',
          'Persönliche Widmung im Kistendeckel'
        ]
      }
    ],

    /* Rastpunkte des Reglers in Euro */
    rastpunkte:  [5, 10, 15, 20, 25, 30, 35, 45, 60, 80, 120, 200, 300],
    startBudget: 20,
    startMenge:  50,
    maxZeilen:   3,     // mehr wäre ein Warenkorb, kein Lead-Formular

    /* ─────────────────────────────────────────────────────────
       6 · HERO-FOTO
       Liegt wie alle anderen Fotos im Shopify-Dateibereich. Hochgeladen
       wird EINE Datei in voller Auflösung (2016 × 3584); die beiden
       Fassungen unten rechnet Shopifys CDN daraus.

       Der Größenparameter ist dabei nicht bloß Feinschliff: Ohne ihn
       liefert Shopify die Datei unverändert als JPEG. Erst mit width=
       greift die Formatverhandlung, und der Browser bekommt WebP –
       gemessen an einem Vergleichsfoto 110 statt 203 KB.

       Es wird immer nur EINE der beiden Fassungen geladen; welche,
       entscheidet die Medienabfrage im CSS. Maßgeblich sind echte
       Bildschirmpunkte, nicht CSS-Pixel: Ein 900-px-Fenster auf einem
       scharfen Display braucht rund 1800 Bildpunkte Breite.

       Fehlt die Datei im Shop, bleibt die Karamellfläche stehen und der
       Text ist trotzdem lesbar – der Hero ist dann schlicht ohne Foto.
       ───────────────────────────────────────────────────────── */
    bilder: {
      /* Schokostack.jpg · 1926 × 3365 im Shop.
         1926 ist die volle Breite – mehr gibt die Datei nicht her, und Shopify
         rechnet nicht hoch. Für die Desktop-Spalte reicht das bis rund 2400 px
         Fensterbreite aus. */
      heroKlein: SHOP_BILD + 'Schokostack.jpg?v=1786469764&width=1200',   // bis 699 px
      heroGross: SHOP_BILD + 'Schokostack.jpg?v=1786469764&width=1926'    // ab  700 px
    },

    /* Wortmarke mit Fuchs, liegt bereits im Shop */
    logo: SHOP_BILD + 'GF_LOGO_RETINA.png?v=1692776069&width=400',

    /* Foto für den Abschnitt „Der Moment“ – jemand bekommt eine Tafel
       überreicht. Sobald es im Shop liegt, hier die vollständige Adresse
       eintragen, zum Beispiel:
       SHOP_BILD + '11-moment.jpg?v=…&width=1800&height=1200&crop=center'
       Solange null: Es wird ein beschrifteter Platzhalter gezeigt und
       keine Datei angefragt. */
    /* 4800 × 3584, also 4:3 – der Abschnitt ist deshalb auf 4:3 ausgelegt.
       Ein 3:2-Zuschnitt hätte oben ins Haar und unten in den Tisch geschnitten. */
    momentBild: SHOP_BILD + 'berreichung_Geschenk.jpg?v=1786456755&width=1800&height=1350&crop=center',
    /* Dasselbe Foto in drei Größen. Am Handy ist es 370 px breit, am Schirm 900 –
       eine einzige 1800er Fassung wog dort 239 KB und war damit das schwerste
       Stück der Seite, am Handy zur Hälfte für nichts. Der Browser wählt anhand
       von momentGroessen selbst. */
    momentQuellen: [800, 1200, 1800].map(function (b) {
      return SHOP_BILD + 'berreichung_Geschenk.jpg?v=1786456755&width=' + b +
             '&height=' + Math.round(b * 0.75) + '&crop=center ' + b + 'w';
    }).join(', '),
    momentGroessen: '(min-width: 1000px) 900px, 100vw',

    /* ─────────────────────────────────────────────────────────
       7 · FRISTEN (echte Daten, kein Fake-Timer)
       ───────────────────────────────────────────────────────── */
    fristen: [
      { datum: '2026-09-14', titel: '14. September', text: 'Frühbesteller-Kondition: Du zahlst den Preis der nächsthöheren Mengenstaffel' },
      { datum: '2026-11-01', titel: '1. November',   text: 'Bestellschluss für individuelle Großpakete und Holzboxen' },
      { datum: '2026-11-20', titel: '20. November',  text: 'Bestellschluss für Logo-Tafeln' },
      { datum: '2026-12-11', titel: '11. Dezember',  text: 'Letzte Zustellung vor Weihnachten' }
    ],

    /* ─────────────────────────────────────────────────────────
       8 · STIMMEN · echte Bewertungen
       Zusammenhängende Ausschnitte, nichts zusammengesetzt.
       Bei Hans Stefan Hintner ist ein Tippfehler korrigiert
       („seitemdem" → „seitdem"), sonst Wortlaut unverändert.
       ───────────────────────────────────────────────────────── */
    /* Hans Stefan Hintner steht bewusst nicht hier, sondern als große
       Einzelstimme weiter oben – er ist der einzige gewerbliche Kunde. */
    stimmen: [
      {
        text: 'Herrlich zart, cremig schmelzend, crunchy und das gewisse Etwas! Und das alles in BIO Qualität. Einfach unwiderstehlich!',
        name: 'Vera Kurz', quelle: 'Google'
      },
      {
        text: 'Fantastische Schokoladen. Vor allem die Erdbeer Chili mit dunkler Schokolade.',
        name: 'Karin Bittermann', quelle: 'Google · Local Guide'
      },
      {
        text: 'Sehr gute Qualität und Geschmack, man merkt die hochwertigen Zutaten!',
        name: 'Wolfgang K.', quelle: 'Shop-Bewertung, verifiziert'
      }
    ],

    /* ─────────────────────────────────────────────────────────
       9 · FORMULAR
       ───────────────────────────────────────────────────────── */
    formular: {
      /* 'shopify'  → Shopifys eigenes Kontaktformular. Jede Absendung kommt als
                      E-Mail an die Adresse aus Einstellungen → Benachrichtigungen.
                      Kein fremder Dienst, keine Kosten – aber Shopify nimmt
                      keine Dateien entgegen, der Logo-Upload entfällt dort.
         'netlify'  → Netlify Forms (die eigenständige index.html). */
      modus:           SHOP ? 'shopify' : 'netlify',
      endpunkt:        SHOP ? '/contact' : '/',
      /* Erste Zeile jeder Benachrichtigungsmail. Danach filtert die
         Weiterleitungsregel im Postfach – in keiner anderen Shop-Mail steht das. */
      art:             'Angebotsanfrage aus dem Konfigurator',
      mindestSekunden: 3,      // Zeitfalle gegen Bots
      maxLogoMB:       8,
      testModus:       false   // true = lokal testen ohne Versand
    },

    /* ─────────────────────────────────────────────────────────
       10 · TRACKING · leer lassen = kein Pixel
       ───────────────────────────────────────────────────────── */
    metaPixelId: ''   // TODO z. B. '123456789012345'
  };

  /* ════════════════════════════════════════════════════════════
     HILFSFUNKTIONEN
     ════════════════════════════════════════════════════════════ */

  var $  = function (s, w) { return (w || document).querySelector(s); };
  var $$ = function (s, w) { return Array.prototype.slice.call((w || document).querySelectorAll(s)); };

  /* Bewusst de-DE: Chrome setzt bei de-AT ein schmales Leerzeichen als
     Tausendertrenner („1 094,50"). Im Geschäftsverkehr steht hier der Punkt. */
  var zahl  = new Intl.NumberFormat('de-DE');
  var zahl2 = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  var zahl0 = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

  /* Betrag vor dem Zeichen: „5,90 €" – Intl liefert für de-AT „€ 5,90". */
  function eur(n)      { return zahl2.format(n) + ' €'; }
  function eurGlatt(n) { return zahl0.format(n) + ' €'; }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  var startZeit = Date.now();
  var reduzierteBewegung = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Versteckte Formularfelder werden über ihren Namen gesetzt. */
  function inAllenFormularen(name, wert) {
    $$('form input[type="hidden"][name="' + name + '"]').forEach(function (e) { e.value = wert; });
  }

  /* ════════════════════════════════════════════════════════════
     KONTAKTDATEN
     ════════════════════════════════════════════════════════════ */

  (function kontaktEinsetzen() {
    var f = CONFIG.firma;

    $$('[data-tel-link]').forEach(function (a) {
      if (f.telefon) {
        a.href = 'tel:' + (f.telefonLink || f.telefon).replace(/[^\d+]/g, '');
        a.textContent = f.telefon;
      } else {
        a.removeAttribute('href');
        a.textContent = 'Telefon eintragen';
        a.style.opacity = '.6';
      }
    });
    $$('[data-mail-link]').forEach(function (a) { a.href = 'mailto:' + f.email; a.textContent = f.email; });
    /* Beim Logo ist ein zerbrochenes Bildsymbol schlimmer als gar kein Logo –
       daneben steht ohnehin „Schokoladenmanufaktur". Also im Fehlerfall
       entfernen, so wie auch bei fehlender Adresse. */
    $$('[data-logo]').forEach(function (e) {
      if (!CONFIG.logo) { e.remove(); return; }
      e.onerror = function () { e.remove(); };
      e.src = CONFIG.logo;
    });

    /* Dasselbe für die Fotos, die fest im Markup stehen und keinen Platzhalter
       haben: lieber eine Lücke als ein kaputtes Bild. */
    $$('img[data-ohne-platzhalter]').forEach(function (e) {
      e.onerror = function () { e.remove(); };
    });

    $$('[data-firmenname]').forEach(function (e) { e.textContent = f.firmenname; });
    $$('[data-adresse]').forEach(function (e) { e.textContent = f.adresse; });
    $$('[data-impressum]').forEach(function (a) { a.href = f.impressum; });
    $$('[data-datenschutz]').forEach(function (a) { a.href = f.datenschutz; });

    var b = CONFIG.bewertung;
    if (b && b.zeile) {
      $$('[data-bewertung]').forEach(function (e) { e.hidden = false; });
      $$('[data-sterne]').forEach(function (e) { e.textContent = '★★★★★ '; });
      $$('[data-bewertung-text]').forEach(function (e) { e.textContent = b.zeile; });
    }
  })();

  /* ════════════════════════════════════════════════════════════
     HERO-BILD
     ════════════════════════════════════════════════════════════ */

  /* Früher stand hier eine WebP-Erkennung, die den Dateinamen von .jpg auf
     .webp umschrieb – nötig, solange die beiden Hero-Fassungen als fertige
     Dateien danebenlagen. Seit das Foto aus dem Shopify-Dateibereich kommt,
     erledigt das die Formatverhandlung des CDN: Der Browser sagt im Accept-
     Kopf, dass er WebP kann, und bekommt WebP. Dafür muss aber ein
     Größenparameter an der Adresse hängen – siehe CONFIG.bilder. */
  (function heroBild() {
    var flaeche = $('#heroFlaeche');
    [['heroKlein', '--hero-klein'], ['heroGross', '--hero-gross']].forEach(function (paar) {
      var quelle = CONFIG.bilder[paar[0]];
      if (!quelle) return;
      /* Nur die Adresse hinterlegen. Welche der beiden Fassungen tatsächlich
         geladen wird, entscheidet allein die Medienabfrage im CSS. */
      flaeche.style.setProperty(paar[1], 'url("' + quelle + '")');
    });
  })();

  (function momentBild() {
    if (!CONFIG.momentBild) return;
    var foto = $('#momentFoto'), platz = $('#momentPlatzhalter');
    foto.hidden = false; platz.hidden = true;
    foto.onerror = function () { foto.hidden = true; platz.hidden = false; };
    /* srcset zuerst, src als Rückfall für Browser ohne Auswahl. */
    if (CONFIG.momentQuellen) {
      foto.sizes  = CONFIG.momentGroessen;
      foto.srcset = CONFIG.momentQuellen;
    }
    foto.src = CONFIG.momentBild;
  })();

  /* ════════════════════════════════════════════════════════════
     SORTEN-LEISTE
     ════════════════════════════════════════════════════════════ */

  (function sortenLeiste() {
    var ziel = $('#sortenLeiste');

    /* Immer beides im Markup: Foto und Platzhalter. Fehlt die Datei, springt
       der Platzhalter ein – sonst stünden hier fünf kaputte Bilder, sobald
       die Gruppe freigeschaltet ist, aber noch nicht alle Fotos da sind.

       <picture> statt <img>: Am Handy der breite 3:4-Zuschnitt, ab 700 px der
       enge. Der Browser lädt nur die eine Fassung, die zu seiner Breite passt –
       zwei Zuschnitte kosten also keine zusätzliche Anfrage. */
    ziel.innerHTML = CONFIG.sorten.map(function (s) {
      return '<div class="sorte" data-reveal>' +
        '<picture>' +
        '<source media="(min-width: 700px)" data-gross>' +
        '<img class="bild" alt="Bio-Schokolade ' + esc(s.name) + '" width="750" height="1000" ' +
        'loading="lazy" decoding="async" hidden>' +
        '</picture>' +
        /* Den Zuschnitt macht Shopifys CDN – gebraucht wird die quadratische
           Ausgangsdatei, nicht ein fertiges 3:4. */
        '<div class="platzhalter"><span>SORTE<b>' + esc(s.datei.split('?')[0]) +
        '</b>quadratisch · mind. 1400 × 1400 px</span></div>' +
        '<h3>' + esc(s.name) + '</h3><p>' + esc(s.detail) + '</p></div>';
    }).join('');

    $$('.sorte', ziel).forEach(function (kachel, i) {
      var datei = CONFIG.sorten[i].datei;
      if (!datei) return;
      var foto = $('img', kachel), platz = $('.platzhalter', kachel);

      /* Bild von Anfang an sichtbar: Ein Bild mit display:none wird von Chrome
         bei loading="lazy" nie angefordert. Bewusst auch keine Vorabprüfung per
         new Image() – die würde alle fünf sofort holen und das Verzögern aushebeln.
         Shopifys CDN liefert von sich aus WebP, wenn der Browser es annimmt. */
      foto.hidden = false;
      platz.hidden = true;
      foto.onerror = function () { foto.hidden = true; platz.hidden = false; };
      $('source', kachel).srcset = SHOP_BILD + datei + SORTE_ZUSCHNITT_GROSS;
      foto.src = SHOP_BILD + datei + SORTE_ZUSCHNITT;
    });
  })();

  /* ════════════════════════════════════════════════════════════
     KONFIGURATOR
     ════════════════════════════════════════════════════════════ */

  var zeilenBehaelter = $('#kZeilen');
  var vorlage = $('[data-zeile]', zeilenBehaelter).cloneNode(true);
  var zeilen = [];
  var laufendeNummer = 0;
  var ansageTimer = null;

  function paketFuerBudget(budget) {
    for (var i = 0; i < CONFIG.pakete.length; i++) {
      var p = CONFIG.pakete[i];
      if (budget >= p.vonBudget && budget <= p.bisBudget) return p;
    }
    return CONFIG.pakete[CONFIG.pakete.length - 1];
  }

  /* Stückpreis inkl. Mengenstaffel. null bei individuellen Paketen. */
  function stueckpreis(paket, menge) {
    if (paket.individuell) return null;
    if (!paket.staffel || !paket.staffel.length) return paket.preis;
    for (var i = 0; i < paket.staffel.length; i++) {
      if (menge >= paket.staffel[i].ab) return paket.staffel[i].preis;
    }
    return paket.preis;
  }

  function erreichteStufe(paket, menge) {
    if (!paket.staffel || !paket.staffel.length) return null;
    for (var i = 0; i < paket.staffel.length; i++) {
      if (menge >= paket.staffel[i].ab && paket.staffel[i].preis < paket.preis) return paket.staffel[i];
    }
    return null;
  }

  /* Nächste erreichbare Stufe – nur wenn sie gegenüber dem aktuellen
     Preis wirklich günstiger ist, sonst stünde „5,90 € statt 5,90 €". */
  function naechsteStufe(paket, menge) {
    if (!paket.staffel || !paket.staffel.length) return null;
    var jetzt = stueckpreis(paket, menge);
    var kandidat = null;
    for (var i = 0; i < paket.staffel.length; i++) {
      var s = paket.staffel[i];
      if (s.ab > menge && s.preis < jetzt && (!kandidat || s.ab < kandidat.ab)) kandidat = s;
    }
    return kandidat;
  }

  function zeileAnlegen(startBudgetWert, startMengeWert) {
    var wurzel = vorlage.cloneNode(true);
    laufendeNummer += 1;
    var nr = laufendeNummer;

    var z = {
      nr: nr,
      wurzel: wurzel,
      regler:      $('[data-regler]', wurzel),
      reglerLabel: $('[data-regler-label]', wurzel),
      reglerWert:  $('[data-regler-wert]', wurzel),
      raster:      $('[data-raster]', wurzel),
      menge:       $('[data-menge]', wurzel),
      mengeLabel:  $('[data-menge-label]', wurzel),
      mengeHilfe:  $('[data-menge-hilfe]', wurzel),
      titel:       $('[data-zeile-titel]', wurzel),
      entfernen:   $('[data-zeile-entfernen]', wurzel),
      karte:       $('[data-karte]', wurzel),
      foto:        $('[data-foto]', wurzel),
      platzhalter: $('[data-platzhalter]', wurzel),
      bilddatei:   $('[data-bilddatei]', wurzel),
      stufe:       $('[data-stufe]', wurzel),
      paketname:   $('[data-paketname]', wurzel),
      inhalt:      $('[data-inhalt]', wurzel),
      preise:      $('[data-preise]', wurzel),
      individuell: $('[data-individuell]', wurzel),
      stueckpreis: $('[data-stueckpreis]', wurzel),
      mengeAnzeige: $('[data-mengeanzeige]', wurzel),
      netto:       $('[data-netto]', wurzel),
      brutto:      $('[data-brutto]', wurzel),
      staffel:     $('[data-staffel]', wurzel),
      mindest:     $('[data-mindest]', wurzel),
      steuer:      $('[data-steuer]', wurzel),
      letztePaketId: null,
      stand: null
    };

    /* Eindeutige Verknüpfungen für Label und Regler */
    z.regler.id = 'regler-' + nr;
    z.reglerLabel.htmlFor = z.regler.id;
    z.reglerWert.setAttribute('for', z.regler.id);
    z.menge.id = 'menge-' + nr;
    z.mengeLabel.htmlFor = z.menge.id;
    z.mengeHilfe.id = 'mengeHilfe-' + nr;
    z.menge.setAttribute('aria-describedby', z.mengeHilfe.id);

    z.regler.max = String(CONFIG.rastpunkte.length - 1);
    z.raster.innerHTML = CONFIG.rastpunkte.map(function () { return '<i></i>'; }).join('');

    var idx = CONFIG.rastpunkte.indexOf(startBudgetWert);
    z.regler.value = idx >= 0 ? idx : 0;
    z.menge.value = startMengeWert;

    z.regler.addEventListener('input', function () { zeileAktualisieren(z); alleAktualisieren(); });
    z.menge.addEventListener('input',  function () { zeileAktualisieren(z); alleAktualisieren(); });
    z.menge.addEventListener('blur',   function () { z.menge.value = mengeAus(z); zeileAktualisieren(z); alleAktualisieren(); });

    $$('[data-menge-schritt]', wurzel).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-menge-schritt'), 10);
        z.menge.value = Math.max(1, Math.min(100000, mengeAus(z) + delta));
        zeileAktualisieren(z); alleAktualisieren();
      });
    });

    z.entfernen.addEventListener('click', function () {
      zeilen = zeilen.filter(function (x) { return x !== z; });
      wurzel.remove();
      zeilenBeschriften();
      alleAktualisieren();
      $('#zeileHinzu').focus();
    });

    /* Foto-Automatik je Zeile */
    z.foto.addEventListener('load',  function () { z.foto.hidden = false; z.platzhalter.hidden = true; });
    z.foto.addEventListener('error', function () { z.foto.hidden = true;  z.platzhalter.hidden = false; });

    zeilenBehaelter.appendChild(wurzel);
    zeilen.push(z);
    zeileAktualisieren(z);
    return z;
  }

  function mengeAus(z) {
    var m = parseInt(z.menge.value, 10);
    if (isNaN(m) || m < 1) m = 1;
    if (m > 100000) m = 100000;
    return m;
  }

  function zeilenBeschriften() {
    zeilen.forEach(function (z, i) {
      z.titel.textContent = 'Geschenk ' + (i + 1);
      z.titel.hidden = zeilen.length < 2;
      z.entfernen.hidden = zeilen.length < 2;
      z.entfernen.setAttribute('aria-label', 'Geschenk ' + (i + 1) + ' entfernen');
      z.reglerLabel.textContent = 'Budget je Empfänger';
      z.regler.setAttribute('aria-label', 'Budget je Empfänger in Euro, Geschenk ' + (i + 1));
    });
    $('#zeileHinzu').hidden = zeilen.length >= CONFIG.maxZeilen;
    $('#kGesamt').hidden = zeilen.length < 2;
  }

  function zeileAktualisieren(z) {
    var budget = CONFIG.rastpunkte[parseInt(z.regler.value, 10)];
    var menge  = mengeAus(z);
    var paket  = paketFuerBudget(budget);
    var preis  = stueckpreis(paket, menge);

    var anteil = (parseInt(z.regler.value, 10) / (CONFIG.rastpunkte.length - 1)) * 100;
    z.regler.style.setProperty('--fuell', anteil + '%');
    z.reglerWert.textContent = eurGlatt(budget);
    z.regler.setAttribute('aria-valuetext', budget + ' Euro je Empfänger – ' + paket.name);

    var gewechselt = paket.id !== z.letztePaketId;
    if (gewechselt && z.letztePaketId !== null && !reduzierteBewegung) {
      z.karte.classList.remove('k-wechsel');
      void z.karte.offsetWidth;
      z.karte.classList.add('k-wechsel');
    }
    if (gewechselt) {
      z.stufe.textContent = 'Stufe ' + paket.stufe + ' von ' + CONFIG.pakete.length;
      z.paketname.textContent = paket.name;
      z.bilddatei.textContent = paket.bild;
      z.inhalt.innerHTML = paket.inhalt.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('');
      /* Ohne hinterlegtes Foto gar nicht erst anfragen – der Platzhalter
         nennt dann den Dateinamen, der noch fehlt. */
      if (paket.foto) {
        z.foto.alt = paket.name + ' – Firmengeschenk von Genussfux';
        z.foto.src = paket.foto;
      } else {
        z.foto.hidden = true; z.platzhalter.hidden = false;
      }
      z.letztePaketId = paket.id;
    }

    var netto = null, brutto = null;
    if (preis === null) {
      z.preise.hidden = true;
      z.individuell.hidden = false;
    } else {
      z.preise.hidden = false;
      z.individuell.hidden = true;
      netto  = preis * menge;
      brutto = netto * (1 + CONFIG.ustSatz);
      z.stueckpreis.textContent  = eur(preis);
      z.mengeAnzeige.textContent = zahl.format(menge);
      z.netto.textContent        = eur(netto);
      z.brutto.textContent       = eur(brutto);
    }

    /* Staffelhinweis */
    var erreicht = erreichteStufe(paket, menge);
    var naechste = naechsteStufe(paket, menge);
    if (erreicht) {
      z.staffel.innerHTML = '<b>Ab ' + zahl.format(erreicht.ab) + ' Stück:</b> ' +
        eur(erreicht.preis) + ' statt ' + eur(paket.preis) +
        ' – du sparst ' + eur(menge * (paket.preis - erreicht.preis)) + '.';
      z.staffel.hidden = false;
    } else if (naechste && preis !== null) {
      z.staffel.innerHTML = '<b>Ab ' + zahl.format(naechste.ab) + ' Stück:</b> ' +
        eur(naechste.preis) + ' statt ' + eur(preis) +
        ' – das wären ' + eur(naechste.ab * (preis - naechste.preis)) + ' weniger.';
      z.staffel.hidden = false;
    } else {
      z.staffel.hidden = true;
    }

    /* Mindestmenge – blockiert nichts */
    if (menge < paket.mindestmenge) {
      z.mindest.innerHTML = 'Unsere Mindestmenge liegt bei <b>' + paket.mindestmenge + ' Stück</b>. ' +
        'Schreib uns trotzdem – für kleinere Mengen finden wir meist eine Lösung.';
      z.mindest.hidden = false;
    } else {
      z.mindest.hidden = true;
    }

    /* Steuerhinweis: eine Zeile, nur unter dem Freibetrag, sonst weg */
    var wert = (preis === null) ? budget : preis;
    if (wert <= CONFIG.freibetragMA) {
      z.steuer.textContent = 'Für Mitarbeitergeschenke abgabenfrei (bis ' +
        eurGlatt(CONFIG.freibetragMA) + ' pro Person und Jahr).';
      z.steuer.hidden = false;
    } else {
      z.steuer.hidden = true;
    }

    z.stand = {
      budget: budget, menge: menge, paket: paket,
      preis: preis, netto: netto, brutto: brutto
    };
  }

  /* Gesamtsumme, Formularübergabe, Sticky-Leiste */
  function alleAktualisieren(quelle) {
    var netto = 0, brutto = 0, hatIndividuell = false, zeigtMischkarton = false;

    zeilen.forEach(function (z) {
      if (z.stand.netto !== null) { netto += z.stand.netto; brutto += z.stand.brutto; }
      else hatIndividuell = true;
      if (z.stand.paket.mischkarton) zeigtMischkarton = true;
    });

    $('#mischkarton').hidden = !zeigtMischkarton;

    if (zeilen.length > 1) {
      $('#kGesamtNetto').textContent = netto > 0 ? eur(netto) + ' netto' : 'auf Anfrage';
      $('#kGesamtBrutto').textContent = netto > 0
        ? eur(brutto) + ' brutto inkl. 10 % USt.' + (hatIndividuell ? ' · individuelle Stufen sind nicht eingerechnet' : '')
        : 'Individuelle Zusammenstellung – wir rechnen sie dir persönlich.';
    }

    /* Übergabe an beide Formulare */
    var erste = zeilen[0];
    ['geschenk-1', 'geschenk-2', 'geschenk-3'].forEach(function (name, i) {
      var z = zeilen[i];
      inAllenFormularen(name, z ? beschreibung(z) : '');
    });
    inAllenFormularen('paket', erste ? (erste.stand.paket.individuell ? erste.stand.paket.name + ' (auf Anfrage)' : erste.stand.paket.name) : '');
    /* Kein 'preis-je-stueck' mehr: Das Feld gab es im Formular nie, der Aufruf
       lief ins Leere. Der Stückpreis steht ohnehin in jeder Geschenk-Zeile. */
    inAllenFormularen('summe-netto',  netto > 0 ? netto.toFixed(2) : '');
    inAllenFormularen('summe-brutto', netto > 0 ? brutto.toFixed(2) : '');
    inAllenFormularen('empfaenger-gesamt', String(zeilen.reduce(function (s, z) { return s + z.stand.menge; }, 0)));

    leadKlasseSetzen();
    zusammenfassungRendern(netto, brutto, hatIndividuell);
    stickyAktualisieren(netto, hatIndividuell);

    clearTimeout(ansageTimer);
    ansageTimer = setTimeout(function () {
      if (!erste) return;
      $('#kAnsage').textContent = erste.stand.paket.name + ', ' +
        (erste.stand.preis === null ? 'individuelle Zusammenstellung' : eur(erste.stand.preis) + ' je Empfänger') +
        ', ' + zahl.format(erste.stand.menge) + ' Stück' +
        (netto > 0 ? ', ' + eur(netto) + ' netto gesamt' : '') + '.';
    }, 500);
  }

  function beschreibung(z) {
    var s = z.stand;
    if (s.preis === null) {
      return s.paket.name + ' · ' + zahl.format(s.menge) + ' Stück · Budget ' + eurGlatt(s.budget) + ' · auf Anfrage';
    }
    return s.paket.name + ' · ' + zahl.format(s.menge) + ' Stück · ' + eur(s.preis) + ' je Stück · ' +
           eur(s.netto) + ' netto';
  }

  /* Live-Zusammenfassung im Anfrage-Panel – der Kunde sieht schwarz auf weiß,
     was er gerade anfragt, und muss oben nichts noch einmal eintippen. */
  function zusammenfassungRendern(netto, brutto, hatIndividuell) {
    var ziel = $('#zusammenfassung');
    if (!ziel) return;

    var zeilenHtml = zeilen.map(function (z) {
      var s = z.stand;
      return '<li><span class="zs-name">' + esc(s.paket.name) + '</span>' +
        '<span class="zs-wert">' + zahl.format(s.menge) + ' × ' +
        (s.preis === null ? 'auf Anfrage' : eur(s.preis)) +
        (s.netto === null ? '' : ' = ' + eur(s.netto)) + '</span></li>';
    }).join('');

    var sorten = $$('#sortenChips input:checked').map(function (i) { return i.value; });

    var gesamt = netto > 0
      ? '<div class="zs-gesamt"><b>Gesamt netto</b><span class="zs-wert">' + eur(netto) + '</span>' +
        '<span class="zs-brutto">' + eur(brutto) + ' brutto inkl. 10 % USt.' +
        (hatIndividuell ? ' · individuelle Stufen sind noch nicht eingerechnet' : '') + '</span></div>'
      : '<div class="zs-gesamt"><b>Gesamt</b><span class="zs-wert">auf Anfrage</span></div>';

    ziel.innerHTML = '<ul>' + zeilenHtml + '</ul>' +
      '<p class="zs-sorten">Sorten: ' + (sorten.length ? esc(sorten.join(', ')) : 'noch keine ausgewählt') + '</p>' +
      gesamt;
  }

  /* Lead-Klasse nach Kapitel 3 – A bei Logo, ab 100 Empfängern oder ab 20 € */
  function leadKlasseSetzen() {
    var hatLogo = $$('input[type="file"]').some(function (e) { return e.files && e.files.length; });
    var gesamtMenge = zeilen.reduce(function (s, z) { return s + z.stand.menge; }, 0);
    var maxPreis = zeilen.reduce(function (s, z) {
      var w = z.stand.preis === null ? z.stand.budget : z.stand.preis;
      return Math.max(s, w);
    }, 0);
    var gruende = [];
    if (hatLogo) gruende.push('Logo hochgeladen');
    if (gesamtMenge >= 100) gruende.push('ab 100 Empfänger');
    if (maxPreis >= 20) gruende.push('ab 20 € je Stück');
    inAllenFormularen('lead-klasse', gruende.length ? 'A (' + gruende.join(', ') + ')' : 'B');
  }

  /* Sortenwahl */
  (function sortenChips() {
    var ziel = $('#sortenChips');
    ziel.innerHTML = CONFIG.sorten.map(function (s) {
      return '<li class="chip"><label>' +
        '<input type="checkbox" name="sorte" value="' + esc(s.name) + '" checked>' +
        '<span>' + esc(s.name) + '</span></label></li>';
    }).join('');
    ziel.addEventListener('change', sortenUebernehmen);
    sortenUebernehmen();
  })();

  function sortenUebernehmen() {
    var gewaehlt = $$('#sortenChips input:checked').map(function (i) { return i.value; });
    inAllenFormularen('sorten', gewaehlt.length ? gewaehlt.join(', ') : 'keine Auswahl');

    /* Premium-Sorten kosten mehr. Der Hinweis erscheint nur, wenn so eine Sorte
       auch wirklich ausgewählt ist – und nennt keinen Gesamtpreis, weil nicht
       feststeht, wie viele Tafeln davon in die Bestellung kommen. */
    var teuer = CONFIG.sorten.filter(function (s) {
      return s.aufpreis && gewaehlt.indexOf(s.name) !== -1;
    });
    var hinweis = $('#aufpreisHinweis');
    if (teuer.length) {
      hinweis.innerHTML = teuer.map(function (s) {
        return '<b>' + esc(s.name) + '</b> ist unsere Premium-Tafel und kostet ' +
               eur(s.aufpreis) + ' je Tafel mehr.';
      }).join(' ') + ' Im Schokoladen-Set und in der Holzbox ist der Aufpreis bereits enthalten.';
      hinweis.hidden = false;
    } else {
      hinweis.hidden = true;
    }

    if (zeilen.length) alleAktualisieren();
  }

  /* Zeile hinzufügen */
  $('#zeileHinzu').addEventListener('click', function () {
    if (zeilen.length >= CONFIG.maxZeilen) return;
    var neu = zeileAnlegen(CONFIG.rastpunkte[0], 20);
    zeilenBeschriften();
    alleAktualisieren();
    neu.regler.focus();
    if (!reduzierteBewegung) neu.wurzel.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* Erste Zeile aufbauen */
  $('[data-zeile]', zeilenBehaelter).remove();
  zeileAnlegen(CONFIG.startBudget, CONFIG.startMenge);
  zeilenBeschriften();

  /* Eine im Formular gewählte Logo-Datei landet auch im jeweils anderen
     Formular, damit der Kunde sie nur einmal auswählen muss. */
  function dateiInsFormular(datei) {
    try {
      $$('form input[type="file"]').forEach(function (feld) {
        var dt = new DataTransfer();
        dt.items.add(datei);
        feld.files = dt.files;
      });
      $$('[data-dateiname]').forEach(function (e) { e.textContent = datei.name; });
    } catch (e) {
      /* Ältere Browser: der Kunde wählt die Datei im zweiten Formular erneut aus. */
    }
  }

  /* ════════════════════════════════════════════════════════════
     STIMMEN
     ════════════════════════════════════════════════════════════ */

  (function stimmenBauen() {
    $('#stimmen').innerHTML = CONFIG.stimmen.map(function (s) {
      return '<figure class="stimme" data-reveal>' +
        '<blockquote>„' + esc(s.text) + '“</blockquote>' +
        '<figcaption>' + esc(s.name) + (s.ort ? ', ' + esc(s.ort) : '') +
        (s.quelle ? '<span class="stimme-quelle">' + esc(s.quelle) + '</span>' : '') +
        (s.platzhalter ? ' <b style="color:var(--gf-fehler)">· PLATZHALTER</b>' : '') +
        '</figcaption></figure>';
    }).join('');

    var b = CONFIG.bewertung;
    if (b && b.stempel) {
      $('#stimmenFuss').innerHTML =
        '<span class="stempel stempel--google" data-reveal>' + esc(b.stempel) + '</span>' +
        '<span class="klein">auf Google und im Shop</span>';
    }
  })();

  /* ════════════════════════════════════════════════════════════
     TERMINE & COUNTDOWN
     ════════════════════════════════════════════════════════════ */

  function fristEnde(f) { return new Date(f.datum + 'T23:59:59'); }

  (function termineBauen() {
    var jetzt = new Date();
    $('#termineBody').innerHTML = CONFIG.fristen.map(function (f) {
      var vorbei = fristEnde(f) < jetzt;
      return '<tr class="' + (vorbei ? 'vorbei' : '') + '">' +
        '<th scope="row">' + esc(f.titel) + '</th>' +
        '<td>' + esc(f.text) + '</td></tr>';
    }).join('');
  })();

  function countdownAktualisieren() {
    var el = $('#countdown');
    var jetzt = new Date();
    var naechste = null;
    for (var i = 0; i < CONFIG.fristen.length; i++) {
      if (fristEnde(CONFIG.fristen[i]) > jetzt) { naechste = CONFIG.fristen[i]; break; }
    }
    if (!naechste) { el.hidden = true; return; }

    var msecs = fristEnde(naechste) - jetzt;
    var tage = Math.floor(msecs / 86400000);
    var stunden = Math.floor(msecs / 3600000);

    if (tage >= 1) {
      $('#countdownZahl').textContent = zahl.format(tage);
      $('#countdownText').textContent = (tage === 1 ? 'Tag' : 'Tage') + ' bis zum ' + naechste.titel + '. ' + naechste.text + '.';
    } else {
      $('#countdownZahl').textContent = zahl.format(stunden);
      $('#countdownText').textContent = (stunden === 1 ? 'Stunde' : 'Stunden') + ' bis zum ' + naechste.titel + '.';
    }
    el.hidden = false;
  }
  countdownAktualisieren();
  setInterval(countdownAktualisieren, 60000);

  /* ════════════════════════════════════════════════════════════
     QUELLE, UTM, ZEITSTEMPEL
     ════════════════════════════════════════════════════════════ */

  (function quelleErfassen() {
    var p = new URLSearchParams(window.location.search);
    inAllenFormularen('quelle',       p.get('q') || '');
    inAllenFormularen('utm-source',   p.get('utm_source') || '');
    inAllenFormularen('utm-medium',   p.get('utm_medium') || '');
    inAllenFormularen('utm-campaign', p.get('utm_campaign') || '');
    inAllenFormularen('utm-content',  p.get('utm_content') || '');
    inAllenFormularen('utm-term',     p.get('utm_term') || '');
    inAllenFormularen('seite',        window.location.href.slice(0, 500));
  })();

  /* ════════════════════════════════════════════════════════════
     META-PIXEL
     ════════════════════════════════════════════════════════════ */

  (function pixelLaden() {
    if (!CONFIG.metaPixelId) return;
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
    (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', CONFIG.metaPixelId);
    window.fbq('track', 'PageView');
  })();

  /* ════════════════════════════════════════════════════════════
     FORMULAR
     Genau eine Strecke: die Angebotsanfrage direkt am Konfigurator.
     Budget und Stückzahl werden nicht abgefragt – die stehen darüber.

     Das frühere zweite Formular („Kostenloses Probierpaket") ist am
     11.08.2026 entfallen: Wer das Paket ohne Konfiguration bekommen
     konnte, war kein Lead, sondern ein Gratis-Abholer. Das Probierpaket
     gibt es jetzt zur Anfrage dazu.
     ════════════════════════════════════════════════════════════ */

  var abgeschickt = false;

  var regeln = {
    firma:        { pruef: function (v) { return v.trim().length >= 2; },
                    text: 'Bitte gib deinen Firmennamen an.' },
    name:         { pruef: function (v) { return v.trim().length >= 2; },
                    text: 'Bitte gib deinen Vor- und Nachnamen an.' },
    email:        { pruef: function (v) { return /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(v.trim()); },
                    text: 'Bitte gib eine gültige E-Mail-Adresse an.' },
    telefon:      { pruef: function (v) { return v.replace(/[^\d]/g, '').length >= 6; },
                    text: 'Bitte gib eine Telefonnummer an – wir melden uns kurz persönlich.' },
    empfaenger:   { pruef: function (v) { var n = parseInt(v, 10); return !isNaN(n) && n >= 1; },
                    text: 'Bitte gib an, für wie viele Empfänger du planst.' },
    budget:       { pruef: function (v) { return v !== ''; },
                    text: 'Bitte wähl ein Budget.' },
    einwilligung: { pruef: function (v, el) { return el.checked; },
                    text: 'Ohne deine Einwilligung dürfen wir dich leider nicht kontaktieren.' },
    logo:         { pruef: function (v, el) { var d = el.files && el.files[0]; return !d || d.size <= CONFIG.formular.maxLogoMB * 1024 * 1024; },
                    text: 'Die Datei ist größer als ' + CONFIG.formular.maxLogoMB + ' MB. Schick sie uns bitte per E-Mail.' }
  };

  /* ─── Versand nach Shopify ────────────────────────────────────────────
     Shopifys Kontaktformular kennt vier feste Felder: name, email, phone und
     body. Die werden von JEDER Fassung der Benachrichtigungsvorlage ausgegeben.
     Ob eigene Zusatzfelder erscheinen, hängt dagegen von der Vorlage ab, die im
     Shop hinterlegt ist – darauf darf ein Lead nicht angewiesen sein.

     Deshalb wandert die vollständige Anfrage als lesbarer Block in `body`.
     Damit kommt sie an, egal welche Vorlage im Shop liegt, und sie steht in der
     Mail in einer sinnvollen Reihenfolge statt in der Reihenfolge der Formular-
     felder. Dateien kann Shopify nicht entgegennehmen; das Logo-Feld entfällt. */
  var MAIL_BLOECKE = [
    ['Firma',    [['firma', 'Firma'], ['name', 'Ansprechpartner'],
                  ['funktion', 'Funktion'], ['telefon', 'Telefon'],
                  ['email', 'E-Mail'], ['strasse', 'Straße'],
                  ['plz', 'PLZ'], ['ort', 'Ort']]],
    ['Geschenk', [['geschenk-1', 'Geschenk 1'], ['geschenk-2', 'Geschenk 2'],
                  ['geschenk-3', 'Geschenk 3'],
                  ['empfaenger-gesamt', 'Empfänger gesamt'],
                  ['summe-netto', 'Summe netto'], ['summe-brutto', 'Summe brutto'],
                  ['sorten', 'Sorten'], ['anlass', 'Anlass'],
                  ['nachricht', 'Nachricht']]],
    ['Herkunft', [['lead-klasse', 'Lead-Klasse'], ['quelle', 'Quelle (QR-Code)'],
                  ['utm-source', 'utm_source'], ['utm-medium', 'utm_medium'],
                  ['utm-campaign', 'utm_campaign'], ['utm-content', 'utm_content'],
                  ['utm-term', 'utm_term'], ['seite', 'Landete auf'],
                  ['zeitstempel', 'Zeitstempel'], ['ausfuellzeit', 'Ausfülldauer'],
                  ['einwilligung', 'Einwilligung erteilt']]]
  ];

  function feldwert(form, feld) {
    var el = form.elements[feld];
    if (!el || !el.tagName || el.type === 'file') return '';
    return el.type === 'checkbox' ? (el.checked ? 'ja' : 'nein') : el.value;
  }

  /* Die Summenfelder bleiben im Formular maschinenlesbar (1867.00), weil Odoo
     sie später so erwartet. In der Mail liest sie ein Mensch – dort also
     1.867,00 €. */
  var MAIL_EURO = { 'summe-netto': 1, 'summe-brutto': 1 };

  function mailtext(form) {
    /* Die erste Zeile der Mail. Sie steht bewusst hier und nicht als Attribut am
       Formular: In Shopify baut den Formular-Tag Liquid, und Attribute mit
       Bindestrich lassen sich dort nicht durchreichen. Nach genau dieser Zeile
       filtert die Weiterleitungsregel im Postfach – sie darf nicht wegfallen. */
    var zeilen = [CONFIG.formular.art || 'Anfrage'];
    MAIL_BLOECKE.forEach(function (block) {
      var teil = [];
      block[1].forEach(function (paar) {
        var wert = feldwert(form, paar[0]);
        if (!wert) return;
        if (MAIL_EURO[paar[0]]) wert = eur(parseFloat(wert));
        teil.push(paar[1] + ': ' + wert);
      });
      if (teil.length) zeilen.push('', teil.join('\n'));
    });
    return zeilen.join('\n');
  }

  /* Kein Datei-Upload in Shopify: Statt ein Feld anzubieten, das nichts tut,
     wird es entfernt und durch den Hinweis ersetzt, das Logo per Antwortmail
     zu schicken. */
  if (CONFIG.formular.modus === 'shopify') {
    $$('form input[type="file"]').forEach(function (feld) {
      var kasten = feld.closest('.feld');
      if (!kasten) return;
      kasten.innerHTML =
        '<label>Dein Logo</label>' +
        '<p class="feld-hilfe">Schick es einfach an <a href="mailto:' +
        esc(CONFIG.firma.email) + '">' + esc(CONFIG.firma.email) + '</a>. ' +
        'Du hörst ohnehin binnen 24 Stunden von mir.</p>';
    });
  }

  /* ─── Absenden wie Shopifys eigenes Kontaktformular ────────────────────
     Ein echtes Formular, vom Browser abgeschickt. Die Feldnamen sind bereits
     die, die Shopify erwartet – es genügt, sie in versteckte Felder zu
     übernehmen. Kodierung und Kopfzeilen macht der Browser, und zwar exakt so,
     wie Shopify es von seinen eigenen Formularen kennt.

     Der vorige Versuch baute dafür ein zweites, unsichtbares Formular und schickte
     es sofort ab. Genau daran lag der Fehler: Shopifys Captcha-Skript hängt sein
     Merkmal an Formulare, die beim Laden der Seite dastehen – ein Formular, das
     erst im Moment des Absendens entsteht, bekommt es nie zu sehen. Ergebnis:
     „Missing CAPTCHA token".

     Jetzt wird das sichtbare Formular selbst abgeschickt. Es stammt aus
     Shopifys form-Tag, steht also von Anfang an im Dokument, und Shopifys
     Skript kennt es. Vorher werden nur die Werte in die contact[…]-Felder
     geschrieben und die eigenen Feldnamen stillgelegt. */

  /* Die eigenen Feldnamen: einmal beim Laden gemerkt. Alles, was Shopify selbst
     beisteuert – form_type, utf8 und was das Captcha-Skript anhängt – bleibt
     unangetastet, weil es hier gar nicht auftaucht. */
  var EIGENE_FELDER = null;

  function eigeneFelderMerken(form) {
    EIGENE_FELDER = [];
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.name && el.name !== 'form_type' && el.name !== 'utf8') {
        EIGENE_FELDER.push(el.name);
      }
    });
  }

  /* Werte in die vier Felder schreiben, die Shopify kennt, und die eigenen
     Felder stilllegen. Abgeschaltete Felder schickt der Browser nicht mit –
     so geht genau das raus, was Shopify erwartet, und nichts sonst. */
  function fuerShopifyVorbereiten(form) {
    var werte = {
      'contact[name]':  feldwert(form, 'firma') + ' · ' + feldwert(form, 'name'),
      'contact[email]': feldwert(form, 'email'),
      'contact[phone]': feldwert(form, 'telefon'),
      'contact[body]':  mailtext(form)
    };

    EIGENE_FELDER.forEach(function (name) {
      var el = form.elements[name];
      if (el && el.tagName) el.disabled = true;
    });

    Object.keys(werte).forEach(function (name) {
      var el = form.querySelector('input[name="' + name + '"]');
      if (!el) {
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        form.appendChild(el);
      }
      el.value = werte[name];
    });
  }

  /* Die Fehlermeldung steht immer im selben Feldkasten – so funktioniert
     dieselbe Prüfung in beiden Formularen ohne doppelte IDs. */
  function fehlerElementVon(el) {
    var kasten = el.closest('.feld, .einwilligung');
    return kasten ? kasten.querySelector('.feld-fehler') : null;
  }

  function pruefeFeld(el) {
    var r = regeln[el.name];
    if (!r) return true;
    var ok = r.pruef(el.value, el);
    var fehlerEl = fehlerElementVon(el);
    if (ok) { el.removeAttribute('aria-invalid'); if (fehlerEl) fehlerEl.textContent = ''; }
    else    { el.setAttribute('aria-invalid', 'true'); if (fehlerEl) fehlerEl.textContent = r.text; }
    return ok;
  }

  function formularAufsetzen(o) {
    var form = o.form;
    if (!form) return;
    var erfolg    = o.erfolg;
    var btn       = $('[data-absenden]', form);
    var fehlerBox = $('[data-absendefehler]', form);
    var btnText   = btn.textContent.trim();
    var laeuft    = false;
    /* Beim zweiten Durchlauf wird das submit-Ereignis nicht mehr abgefangen –
       nur so kommen Shopifys eigene Zuhörer dran und hängen das Captcha-Merkmal
       an. Wer hier preventDefault ruft, schneidet sie ab. */
    var durchlassen = false;

    if (CONFIG.formular.modus === 'shopify') eigeneFelderMerken(form);

    Object.keys(regeln).forEach(function (feldName) {
      var el = form.elements[feldName];
      if (!el || !el.tagName) return;
      el.addEventListener('blur', function () { pruefeFeld(el); });
      el.addEventListener('change', function () {
        if (el.getAttribute('aria-invalid') === 'true' || el.type === 'checkbox') pruefeFeld(el);
      });
    });

    /* Logo: füttert die Vorschau und landet gleichzeitig im anderen Formular */
    var logoFeld = form.elements['logo'];
    if (logoFeld) {
      logoFeld.addEventListener('change', function () {
        var d = logoFeld.files && logoFeld.files[0];
        if (d) dateiInsFormular(d);
        else $$('[data-dateiname]').forEach(function (e) { e.textContent = 'PDF, SVG, EPS oder PNG'; });
        pruefeFeld(logoFeld);
        leadKlasseSetzen();
      });
    }

    function alleFelderPruefen() {
      var erster = null;
      Object.keys(regeln).forEach(function (feldName) {
        var el = form.elements[feldName];
        if (!el || !el.tagName) return;
        if (!pruefeFeld(el) && !erster) erster = el;
      });
      return erster;
    }

    function erfolgAnzeigen(netto) {
      form.hidden = true;
      erfolg.hidden = false;
      abgeschickt = true;
      $$('[data-erfolgdatum]', erfolg).forEach(function (e) {
        e.textContent = new Date().toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
      });
      var titel = $('[data-erfolgtitel]', erfolg);
      if (titel) titel.focus();
      $('#sticky').classList.remove('zeigt');

      if (window.fbq) window.fbq('track', 'Lead', netto ? { value: netto, currency: 'EUR' } : {});
      try {
        history.replaceState(null, '', window.location.pathname + window.location.search + o.hash);
      } catch (e) { /* egal */ }

      erfolg.scrollIntoView({ behavior: reduzierteBewegung ? 'auto' : 'smooth', block: 'center' });
    }

    /* ─── Warum am Knopf und nicht am submit-Ereignis ──────────────────────
       Shopifys Captcha-Skript hört auf das submit-Ereignis des Formulars. Läge
       unsere Prüfung dort, gäbe es zwei Ereignisse: eines beim Klick (das wir
       abbrechen, um zu prüfen) und eines beim tatsächlichen Abschicken. Shopifys
       Zuhörer liefe dann zweimal und könnte sein Merkmal doppelt anhängen –
       ob das stört, hängt von seiner Umsetzung ab, und darauf soll es nicht
       ankommen.

       Deshalb wird schon der Klick abgefangen. In der ersten Runde entsteht gar
       kein submit-Ereignis; erst wenn alles geprüft und eingetragen ist, löst
       requestSubmit genau eines aus. Shopifys Zuhörer läuft damit exakt einmal.

       Die Eingabetaste in einem Textfeld löst sonst direkt ein submit aus –
       sie wird deshalb weiter unten auf denselben Weg umgeleitet. */
    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (laeuft) return;
      fehlerBox.hidden = true;

      var erster = alleFelderPruefen();
      if (erster) {
        erster.focus();
        erster.scrollIntoView({ behavior: reduzierteBewegung ? 'auto' : 'smooth', block: 'center' });
        return;
      }

      /* Honeypot: gefüllt = Bot. Kein Versand, keine Rückmeldung. */
      var honig = form.elements[o.honeypot];
      if (honig && honig.value !== '') return;

      /* Zeitfalle: zu früh abgeschickt → verzögern statt verwerfen,
         damit ein echter Mensch nie verloren geht. */
      var vergangen = (Date.now() - startZeit) / 1000;
      if (vergangen < CONFIG.formular.mindestSekunden) {
        laeuft = true;
        btn.setAttribute('aria-busy', 'true');
        setTimeout(function () {
          laeuft = false;
          btn.removeAttribute('aria-busy');
          btn.click();
        }, (CONFIG.formular.mindestSekunden - vergangen) * 1000 + 100);
        return;
      }

      form.elements['zeitstempel'].value  = new Date().toISOString();
      form.elements['ausfuellzeit'].value = Math.round(vergangen) + ' s';
      var netto = parseFloat(form.elements['summe-netto'].value) || 0;

      laeuft = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Wird gesendet …';

      if (CONFIG.formular.testModus) {
        setTimeout(function () { erfolgAnzeigen(netto); }, 400);
        return;
      }

      /* ─── In Shopify: das sichtbare Formular selbst abschicken ──────────
         Es stammt aus Shopifys form-Tag, steht also seit dem Laden im
         Dokument – nur solche Formulare versieht Shopifys Skript mit dem
         Captcha-Merkmal. Werte in die contact[…]-Felder schreiben, eigene
         Feldnamen stilllegen, dann den Browser übernehmen lassen.

         requestSubmit statt submit: submit() würde die Ereignisse übergehen,
         und genau daran hängt Shopifys Skript.

         Danach leitet Shopify auf diese Seite mit contact_posted=true zurück,
         wo die Erfolgsansicht greift (siehe unten). Der Preis ist ein
         Seitenwechsel – für ein Formular, das ein Besucher einmal ausfüllt,
         ist das der richtige Tausch. */
      if (CONFIG.formular.modus === 'shopify') {
        fuerShopifyVorbereiten(form);
        durchlassen = true;
        if (form.requestSubmit) form.requestSubmit(btn);
        else form.submit();
        return;
      }

      /* Außerhalb von Shopify (die eigenständige index.html zum Ansehen) */
      fetch(CONFIG.formular.endpunkt, { method: 'POST', body: new FormData(form) })
        .then(function (antwort) {
          if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
          erfolgAnzeigen(netto);
        })
        .catch(function () {
          laeuft = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = btnText;
          fehlerBox.hidden = false;
          fehlerBox.innerHTML = 'Das Absenden hat leider nicht funktioniert. ' +
            'Bitte versuch es noch einmal oder schreib uns direkt an ' +
            '<a href="mailto:' + esc(CONFIG.firma.email) + '">' + esc(CONFIG.firma.email) + '</a>.';
        });
    });

    /* Die Eingabetaste in einem Feld würde das Formular direkt abschicken und
       damit an der Prüfung vorbei. Sie wird auf den Knopf umgeleitet – im
       mehrzeiligen Nachrichtenfeld bleibt sie ein Zeilenumbruch. */
    form.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Enter' || ev.shiftKey) return;
      if (ev.target.tagName === 'TEXTAREA') return;
      ev.preventDefault();
      btn.click();
    });

    /* Sicherheitsnetz: Was auch immer sonst ein Abschicken auslöst – solange
       nicht geprüft und vorbereitet wurde, geht nichts raus. */
    form.addEventListener('submit', function (ev) {
      if (!durchlassen) ev.preventDefault();
    });

    /* Rückkehr von Shopify: Der Kunde war zwischendurch weg, die Seite ist neu
       geladen und der Konfigurator wieder auf Anfang. Angekommen ist die
       Anfrage trotzdem – also gehört hierher die Erfolgsansicht und nicht ein
       leeres Formular, das zum zweiten Absenden einlädt. */
    if (/[?&]contact_posted=true/.test(window.location.search)) erfolgAnzeigen(null);
  }

  formularAufsetzen({
    form: $('#konfigFormular'), erfolg: $('#konfigErfolg'),
    honeypot: 'firmen-web', hash: '#danke-angebot'
  });
  /* Anfrage-Panel am Konfigurator aufklappen */
  function anfragePanelOeffnen(fokus) {
    var btn = $('#konfigAnfragen');
    var panel = $('#konfigPanel');
    panel.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    btn.hidden = true;
    if (!reduzierteBewegung) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (fokus !== false) setTimeout(function () { $('#konfigPanelTitel').focus(); }, reduzierteBewegung ? 0 : 500);
  }
  $('#konfigAnfragen').addEventListener('click', function () { anfragePanelOeffnen(); });

  /* Die Sticky-Leiste zeigt den konfigurierten Preis – ihr Knopf führt
     folgerichtig zurück zur Zusammenstellung und klappt dort das Formular auf. */
  $('#stickyCta').addEventListener('click', function () {
    if ($('#konfigPanel').hidden) anfragePanelOeffnen(false);
  });

  /* ════════════════════════════════════════════════════════════
     STICKY-LEISTE (nur Handy)
     ════════════════════════════════════════════════════════════ */

  var stickyErlaubt = false;

  function stickyAktualisieren(netto, hatIndividuell) {
    if (netto > 0) {
      $('#stickyPreis').textContent = eur(netto) + ' netto';
      $('#stickyText').textContent = zeilen.length > 1
        ? zeilen.length + ' Geschenke' + (hatIndividuell ? ' · plus individuell' : '')
        : zeilen[0].stand.paket.name + ' · ' + zahl.format(zeilen[0].stand.menge) + ' Stück';
    } else {
      $('#stickyPreis').textContent = 'Auf Anfrage';
      $('#stickyText').textContent = 'Individuelle Zusammenstellung';
    }
  }

  (function stickyBeobachten() {
    var leiste = $('#sticky');
    if (!('IntersectionObserver' in window)) return;
    document.body.classList.add('hat-sticky');

    var formularSichtbar = false;

    /* Nach dem Absenden verschwindet die Leiste dauerhaft. */
    function stand() {
      leiste.classList.toggle('zeigt', stickyErlaubt && !formularSichtbar && !abgeschickt);
    }

    /* Erst zeigen, wenn der Hero durch ist … */
    new IntersectionObserver(function (e) {
      stickyErlaubt = !e[0].isIntersecting;
      stand();
    }, { threshold: 0 }).observe($('#heroFlaeche'));

    /* … und wieder verstecken, sobald das Formular im Blick ist. */
    new IntersectionObserver(function (e) {
      formularSichtbar = e[0].isIntersecting;
      stand();
    }, { threshold: 0 }).observe($('#konfigurator'));
  })();

  /* ════════════════════════════════════════════════════════════
     EINBLENDUNGEN BEIM SCROLLEN
     ════════════════════════════════════════════════════════════ */

  (function einblenden() {
    var elemente = $$('[data-reveal]');
    if (reduzierteBewegung || !('IntersectionObserver' in window)) {
      elemente.forEach(function (e) { e.classList.add('sichtbar'); });
      return;
    }

    /* Nur was beim Laden unter dem Falz liegt, wird versteckt.
       Der Hero bleibt unangetastet – eine animierte Überschrift
       verzögert sonst den größten Inhaltsaufbau (LCP). */
    var spaeter = elemente.filter(function (el) {
      return el.getBoundingClientRect().top >= window.innerHeight * 0.9;
    });
    spaeter.forEach(function (el) { el.classList.add('vor-einblendung'); });

    var zaehler = new Map();
    spaeter.forEach(function (el) {
      var eltern = el.parentElement;
      var i = zaehler.get(eltern) || 0;
      el.style.setProperty('--verzug', Math.min(i, 5) * 60 + 'ms');
      zaehler.set(eltern, i + 1);
    });

    var beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sichtbar'); beobachter.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    spaeter.forEach(function (el) { beobachter.observe(el); });

    /* Sicherheitsnetz: Falls der Beobachter nach 1,5 s nichts ausgelöst hat,
       obwohl Elemente im Sichtfeld stehen, wird der Effekt abgeschaltet.
       Eine leere Seite ist unter allen Umständen das schlechtere Ergebnis. */
    setTimeout(function () {
      var imBlick = spaeter.filter(function (el) {
        var r = el.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      });
      if (imBlick.length && !imBlick.some(function (el) { return el.classList.contains('sichtbar'); })) {
        beobachter.disconnect();
        elemente.forEach(function (el) { el.classList.remove('vor-einblendung'); });
      }
    }, 1500);
  })();

  /* Startzustand */
  alleAktualisieren();

})();
